module.exports = __webpack_public_path__ + "img/img_loading.d71d8ccb.gif";